export const CUSTOMER_PORTAL = 'customer-portal';
export const STUDIO_EMBEDDED = 'studio-embedded';
export const WEBSITE = 'website';

// when you update this value you also need to update
// the static value in layout.css
export const NAVIGATION_COLLAPSE_POINT = '960px';
